import React from 'react'
import styled, { css } from 'styled-components'

import { switchProp } from 'styled-tools'
import PropTypes from 'prop-types'
import Logo from './Logo.png'
import Artwork from './Classic.svg'

ContentWrapper.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'lg'])
}

function ContentWrapper({ children, size = 'sm' }) {
  const randomSeed = Math.floor(Math.random() * 99999) + 10000

  const learnMore = 'https://www.schoolstatus.com/blog/a-unified-future-transforming-student-outcomes'

  return (
    <Wrapper>
      <LeftSection>
        <LeftSectionElements>
          <img height="23px" width="269px" src={Logo} />
          <LeftSectionContent>
            <LeftSectionText>
              <h4 className='m-0' style={{ color: '#BAE6FD', fontSize: '18px' }}>
                SchoolStatus has a new look!
              </h4>
              <div className='content-text'>
                SchoolStatus has an updated look and is now called
                <span style={{ fontWeight: 'bold' }}> SchoolStatus Classic</span>
                , but everything else you know and love is still right here.
              </div>
              <div className='content-text'>
                Sign in here the same way you always have. You can also <a href={learnMore}>read more about our rebrand</a> and
                the new things to expect!
              </div>
            </LeftSectionText>
          </LeftSectionContent>
         </LeftSectionElements>
        <ArtworkWrapper>
          <div className="login-artwork">
            <img style={{ transform: 'scale(1)' }} src={Artwork} />
          </div>
        </ArtworkWrapper>
      </LeftSection>
      <MainContent>
        <TopSection>
          <a style={{ fontWeight: '400', color: 'black' }} href="https://www.schoolstatus.com/schoolstatus-help-center">
            Get Help
          </a>
          <a style={{ fontWeight: '400', color: 'black' }} href="https://ss.ly/OybYsB">
            News
          </a>
        </TopSection>
        <LoginSection>
          {children}
        </LoginSection>
      </MainContent>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  font-family: text--default;
  background-color: white;

  @media (max-width: 992px) {
    .login-artwork img {
      transform: scale(1.1) !important;
    }
   }
`
const LeftSection = styled.section`
  min-height: 100vh;
  opacity: 1 !important;
  background-color: #1E2425;
  display: flex;
  height: 100%;
  width: 450px;
  padding: 32px 37px 100px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex-shrink: 0;

  @media (max-width: 992px) {
    width: 320px;
    padding: 30px;
   }
`

const LeftSectionElements = styled.div`
    display: flex;
    flex-direction: column;
    gap: 144px;
`

const LeftSectionContent = styled.div`
  display: flex;
  width: 380px;
  flex-direction: column;
  align-items: center;
  gap: 72px;
  color: white;

  @media (max-width: 992px) {
    width: 275px;
   }
`

const LeftSectionText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  .content-text{
    color: white !important;
    font-size: 16px !important;
  }

    @media (max-width: 992px) {
      .content-text{
        margin-top: 5px;
      }
   }
`

const ArtworkWrapper = styled.div`
  width: 100%;
  height: 100%;
`

const MainContent = styled.div`
  display: flex;
  height: 100%;
  padding: 10px 85px 0px 85px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex-shrink: 0;
  width: calc(100% - 450px);
  background-color: white;

  @media (max-width: 992px) {
    width: calc(100% - 290px);
  }

`
const TopSection = styled.div`
  display: flex;
  padding: 8px 0px 125px 0px;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  height: 20%;
  text-align: right;
`

const LoginSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`

export default ContentWrapper
